<div class="panel panel-default">
<div class="panel-title" id="{{'V319-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + getDetailType()}}">
  <span class="field-code">V319</span> 
  {{getDetailType()}}
</div>
<div class="panel-body panel-body-bottom">
   <ul style="list-style: none;">
    <li *ngFor="let abstractDetail of getAbstractDetailList(); let ad = index" >
      <span class="field-code">
          V068 json='abstractPartyRole.casePartyRef' 
      </span>
      <span id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-detailPartyName'}}"> 
        {{abstract.getAbstractDetailPartyName(civilCase, abstractDetail)}}
      </span>
      <span class="field-code">                    
          V052 V053 json='abstractPartyRole.casePartyRef' 
      </span> 
      <span id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-detailDescription'}}">
        ({{abstract.getAbstractDetailPartyDescription(civilCase, abstractDetail)}})
      </span>
      <span class="field-code">                    
          V321 V239 json='abstractDetailStatus.description' 
      </span> 
      <span id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-detailStatus'}}">
       {{abstract.returnIfNotEmpty(abstract.getAbstractPartyLiableStatus(abstractDetail), ' (')}}{{abstract.getAbstractPartyLiableStatus(abstractDetail)}} 
       {{abstract.getDetailPartyLiableCancelDate(abstractDetail) | date: 'MM/dd/yyyy'}}{{abstract.returnIfNotEmpty(abstract.getAbstractPartyLiableStatus(abstractDetail), ')')}}
      </span>
     
        <div class="col-sm-12 panel panel-default" 
            *ngIf="getShowDebtorSection() && (abstract.getMaxPreLiabilityAmount(abstractDetail) !== 0 || abstract.getMaxPostLiabilityAmount(abstractDetail) !== 0)">
          <div class="panel-title" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-debtorDetailName'}}">
              <span class="field-code">V286</span>Debtor's Maximum Liability on {{getDebtorDetailName()}}
          </div>
          <div class="panel-body panel-body-bottom">
            <dl class="dl-vertical dl-margin-bottom">
              <dt class="summary-label"> 
                <div *ngIf="getDetailName() === 'cost' && abstract.getMaxPreLiabilityAmount(abstractDetail) !== 0" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-attachedCostsLabel'}}"><span class="field-code">V370 json='detail name# (cost or money)'</span>
                   Attached Costs
                  </div>
                <div *ngIf="getDetailName() !== 'cost'  && abstract.getMaxPostLiabilityAmount(abstractDetail) !== 0" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-principalLabel'}}"><span class="field-code">V371 json='detail name# (cost or money)'</span>
                   Principal
                  </div>
              </dt>
              <dd> 
                <div *ngIf="getDetailName() === 'cost' && abstract.getMaxPreLiabilityAmount(abstractDetail) !== 0" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-attachedCosts'}}">
                  <span class="field-code">V370 json='maxPreLiabilityAmount'</span>
                  {{abstract.getMaxPreLiabilityAmount(abstractDetail) | currency:'USD':'symbol':'1.2-2'}}</div>
                <div *ngIf="getDetailName() !== 'cost' && abstract.getMaxPostLiabilityAmount(abstractDetail) !== 0" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-principal'}}">
                  <span class="field-code">V371 json='maxPostLiabilityAmount'</span>
                  {{abstract.getMaxPostLiabilityAmount(abstractDetail) | currency:'USD':'symbol':'1.2-2'}}
                </div>
              </dd>

              <dt class="summary-label">
                <div *ngIf="getDetailName() === 'cost' && abstract.getMaxPostLiabilityAmount(abstractDetail) !== 0" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-otherLabel'}}"><span class="field-code">V374 json='detail name# (cost or money)'</span>
                   Other</div>
                <div *ngIf="getDetailName() !== 'cost' && abstract.getMaxPreLiabilityAmount(abstractDetail) !== 0" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-preJudgmentInterestLabel'}}"><span class="field-code">V373 json='detail name# (cost or money)'</span>
                   Pre-Judgment Interest</div>
              </dt>
              <dd>
                  <div *ngIf="getDetailName() === 'cost' && abstract.getMaxPostLiabilityAmount(abstractDetail) !== 0" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-other'}}">
                    <span class="field-code">V374 json='maxPostLiabilityAmount'</span>
                    {{abstract.getMaxPostLiabilityAmount(abstractDetail) | currency:'USD':'symbol':'1.2-2'}}
                  </div>
                 <div *ngIf="getDetailName() !== 'cost' && abstract.getMaxPreLiabilityAmount(abstractDetail) !== 0" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-preJudgmentInterest'}}">
                   <span class="field-code">V373 json='maxPreLiabilityAmount'</span>
                  {{abstract.getMaxPreLiabilityAmount(abstractDetail) | currency:'USD':'symbol':'1.2-2'}}</div>
              </dd>
              <div *ngIf="abstract.getMaxAttorneyAmount(abstractDetail) !== 0">
                <dt class="summary-label" id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-attorneyAmountLabel'}}">
                  <span class="field-code">V377 V378 json='maxAttorneyAmount'</span>Attorney Amount
                </dt>
                <dd id="{{'civil-caseDetails-judgmentAbstracts-' + getJaIndex() + '-' + getDetailName() + 'Detail-' + ad + '-' + getDetailType() + '-attorneyAmount'}}">
                  {{abstract.getMaxAttorneyAmount(abstractDetail) | currency:'USD':'symbol':'1.2-2'}}
                </dd>
            </div>
            </dl>
          </div>
        </div>
    </li>
  </ul>
</div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/judgments/creditor-section.component.html